import {
  LICENSE_LOADING, GET_LICENSES_CUSTOMER, GET_DETAIL_LICENSES_CUSTOMER,
  CLEAR_LICENSES_CUSTOMER, SET_CHIPS_FILTERS_LICENSES, CHANGE_CHIPS_FILTERS_LICENSES,
  ADD_LICENSE_CUSTOMER, LICENSE_SHOW_MESSAGE, GET_CUSTOMER_INFORMATION_LICENSE,
  GET_LICENSE_INFORMATION, GET_MANAGERS, GET_APP_PARAMETERS_CONTRACTS,
  GET_CONTRACT_DATA, GET_SERVICES_DATA_DASHBOARD,
  GET_DETAIL_CONTRACTS, GET_HISTORY_CONSUMPTION_DASHBOARD, GET_REQUEST_DASHBOARD,
  GET_CONTRACT_CUSTOMER_INFO, GET_CONTRACT_SUPERVISOR_INFO, GET_CONTRACT_DETAILS,
  GET_AGREEMENTS_LIST, GET_INFORMATION_AGREEMENT, MODIFY_INFORMATION_AGREEMENT,
  LICENSE_LOADING_UPDATE_AGREEMENT, GET_RISK_OFFICERS, GET_CART_SUCCESS, UPDATE_LOCAL_QUANTITY,
  LOADING_MARKET_PLACE, REMOVE_CART_ITEM, GET_LICENSES_SUCCESS, UPDATE_LICENSE_DATA, DELETE_LICENSE_ASSIGNMENT,
  GET_CART_ERROR, LICENSE_LOADING_SAVE_ORDER, GET_ITEMS_CATALOG, UPDATE_CART_ITEM_FULL, LOADING_LOAD_PRODUCTS_ASSIGNMENTS,
  LICENSE_SAVE_ORDER_SUCCESS, SET_MARKET_CONTEXT, SAVE_ASSIGNMENTS_SUCCESS, SAVING_ASSIGNMENTS_LOADING, SAVE_ORDER_SUCCESS,
  SAVE_ORDER_MARKET_ERROR, PRODUCT_WAS_ASSIGNED,
  PAYMENT_RESULT, ADD_PROMO_TO_LIST, LOADING_VALIDATE_PROMO_CODE, SET_PROMO_FEEDBACK, LOADING_CONTRACT_CUSTOMER_INFO,
  LOADING_CONTRACT_SUPERVISOR_INFO,
  COUNTRIES_FLAGS, CUSTOMER_ASSIGNED_CONTRACTS, CLEAR_SERVICES_DATA_DASHBOARD, GET_CUSTOMER_EDIT_INFORMATION_LICENSE,
  LOADING_CUSTOMER_EDIT_INFORMATION, LICENSE_LOADING_UPDATE_CUSTOMER, LOADING_CONTRACT_ANNULMENT, CONTRACT_ANNULMENT
} from '../types/license.type';

const INITIAL_STATE = {
  loading: false,
  detailLicenses: [],
  licenseCustomer: [],
  chipsFiltersOptions: [],
  licenseCustomerRowsNum: null,
  nextSkipLicense: null,
  addLicenseCustomer: [],
  licenseShowMessageAlert: undefined,
  customerServiceInfoLicense: {},
  getLicenseInformation: [],
  gestorType: [],
  listDocumentTypeContracts: [],
  listPaymentTypeContracts: [],
  listValidityTypeContracts: [],
  listDeviceTypeContracts: [],
  listCredentialDeliveryContracts: [],
  parameterMaxReassignmentQuota: 5,
  showLegalRepresentativeContract: false,
  startDateParams: {},
  getContractData: {},
  getServicesDataDashboard: [],
  detailContracts: [],
  getHistoryConsumptionDashboard: {},
  getRequestDashboard: {},
  getContractCustomerInfo: {},
  getContractSupervisorInfo: {},
  getContractDetails: [],
  agreementsList: [],
  getInformationAgreementResponse: {},
  modifyInformationAgreementResponse: {},
  loadingUpdateAgreementResponse: false,
  parameterMaxValidityContract: 2,
  alertPeriodicityParams: {},
  riskOfficers: [],
  riskOfficerRole: '',
  loadingMarketPlace: false,
  getCartError: false,
  redirectUrl: null,
  licenseLoadingSaveOrder: false,
  getItemsCatalog: [],
  loadingLoadProductsAssignments: false,
  licenseSaveOrderSuccess: false,
  saveAssignmentsSuccess: false,
  savingAssignmentsLoading: false,
  saveOrderSuccess: {},
  saveOrderMarketError: null,
  productWasAssigned: false,
  paymentResult: {},
  errorMessage: '',
  appliedPromos: JSON.parse(sessionStorage.getItem('cart_promos')) || [],
  loadingValidatePromoCode: false,
  promoFeedback: { message: '', isError: false },
  loadingContractCustomerInfo: false,
  loadingContractSupervisorInfo: false,
  countriesFlags: [],
  customerAssignedContracts: [],
  customerServiceEditInfoLicense: {},
  loadingCustomerEdit: false,
  loadingUpdateCustomer: false,
  loadingContractAnnulment: false,
  contractAnnulmentResult: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_LICENSES_CUSTOMER:
      return {
        ...state,
        licenseCustomer: action.payload,
        licenseCustomerRowsNum: action.rownums,
        nextSkipLicense: action.nextSkipLicense,
      };
    case GET_DETAIL_LICENSES_CUSTOMER:
      return {
        ...state,
        detailLicenses: action.payload,
      };
    case SET_CHIPS_FILTERS_LICENSES:
      return {
        ...state,
        chipsFiltersOptions: action.payload,
      };
    case CHANGE_CHIPS_FILTERS_LICENSES:
      return {
        ...state,
        chipsFiltersOptions: action.payload,
      };
    case CLEAR_LICENSES_CUSTOMER:
      return {
        ...state,
        detailLicenses: action.payload,
      };
    case ADD_LICENSE_CUSTOMER:
      return {
        ...state,
        addLicenseCustomer: action.payload,
      };
    case LICENSE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case LICENSE_SHOW_MESSAGE:
      return {
        ...state,
        licenseShowMessageAlert: action.payload,
      };
    case GET_CUSTOMER_INFORMATION_LICENSE:
      return {
        ...state,
        customerServiceInfoLicense: action.payload,
      };
    case GET_LICENSE_INFORMATION:
      return {
        ...state,
        getLicenseInformation: action.payload,
      };
    case GET_MANAGERS:
      return {
        ...state,
        gestorType: action.payload,
      };
    case GET_APP_PARAMETERS_CONTRACTS:
      return {
        ...state,
        listPaymentTypeContracts: action.listPaymentTypeContracts,
        listDocumentTypeContracts: action.listDocumentTypeContracts,
        listValidityTypeContracts: action.listValidityTypeContracts,
        listDeviceTypeContracts: action.listDeviceTypeContracts,
        listCredentialDeliveryContracts: action.listCredentialDeliveryContracts,
        parameterMaxReassignmentQuota: action.parameterMaxReassignmentQuota,
        showLegalRepresentativeContract: action.showLegalRepresentativeContract,
        startDateParams: action.startDateParams,
        transformedListMaxValidityAmountContracts: action.transformedListMaxValidityAmountContracts,
        parameterMaxValidityContract: action.parameterMaxValidityContract,
        alertPeriodicityParams: action.alertPeriodicityParams,
        riskOfficerRole: action.riskOfficerRole,
        listCredentialParams: action.listCredentialParams,
        opportunityInputValidation: action.opportunityInputValidation,
      };
    case GET_CONTRACT_DATA:
      return {
        ...state,
        getContractData: action.payload,
      };
    case GET_SERVICES_DATA_DASHBOARD:
      return {
        ...state,
        getServicesDataDashboard: action.payload,
      };
    case GET_DETAIL_CONTRACTS:
      return {
        ...state,
        detailContracts: action.payload,
      };
    case GET_HISTORY_CONSUMPTION_DASHBOARD:
      return {
        ...state,
        getHistoryConsumptionDashboard: action.payload,
      };
    case GET_REQUEST_DASHBOARD:
      return {
        ...state,
        getRequestDashboard: action.payload,
      };
    case GET_CONTRACT_CUSTOMER_INFO:
      return {
        ...state,
        getContractCustomerInfo: action.payload,
      };
    case GET_CONTRACT_SUPERVISOR_INFO:
      return {
        ...state,
        getContractSupervisorInfo: action.payload,
      };
    case GET_CONTRACT_DETAILS:
      return {
        ...state,
        getContractDetails: action.payload,
      };
    case GET_AGREEMENTS_LIST:
      return {
        ...state,
        agreementsList: action.payload,
      };
    case GET_INFORMATION_AGREEMENT:
      return {
        ...state,
        getInformationAgreementResponse: action.payload,
      };
    case MODIFY_INFORMATION_AGREEMENT:
      return {
        ...state,
        modifyInformationAgreementResponse: action.payload,
      };
    case LICENSE_LOADING_UPDATE_AGREEMENT:
      return {
        ...state,
        loadingUpdateAgreementResponse: action.payload,
      };
    case GET_RISK_OFFICERS:
      return {
        ...state,
        riskOfficers: action.payload,
      };
    case GET_CART_SUCCESS:
      return {
        ...state,
        cartData: action.payload,
      };
    case UPDATE_LOCAL_QUANTITY:
      return {
        ...state,
        cartData: {
          ...state.cartData,
          cartItems: state.cartData.cartItems.map((item) => (item.identifierCode === action.payload.identifierCode
            ? { ...item, quantity: Math.min(Math.max(1, item.quantity + action.payload.delta), action.payload.maxQuantity) }
            : item)),
        },
      };
    case REMOVE_CART_ITEM:
      return {
        ...state,
        cartData: {
          ...state.cartData,
          cartItems: state.cartData.cartItems.filter((item) => item.identifierCode !== action.payload),
        },
      };
    case UPDATE_CART_ITEM_FULL:
      return {
        ...state,
        cartData: {
          ...state.cartData,
          cartItems: state.cartData.cartItems.map((item) => (item.identifierCode === action.payload.oldId
            ? action.payload.newItem
            : item)),
        },
      };
    case LOADING_MARKET_PLACE:
      return {
        ...state,
        loadingMarketPlace: action.payload,
      };
    case GET_LICENSES_SUCCESS:
      return {
        ...state,
        itemsToAssign: action.payload,
      };

    case UPDATE_LICENSE_DATA:
      return {
        ...state,
        itemsToAssign: state.itemsToAssign.map((item) => (item.id === action.payload.id
          ? { ...item, status: 'Asignado', assigned: action.payload.holderData }
          : item)),
      };

    case DELETE_LICENSE_ASSIGNMENT:
      return {
        ...state,
        itemsToAssign: state.itemsToAssign.map((item) => (item.id === action.payload
          ? { ...item, status: 'Pendiente', assigned: null }
          : item)),
      };
    case GET_CART_ERROR:
      return {
        ...state,
        getCartError: action.payload.hasError,
        redirectUrl: action.payload.url,
      };
    case LICENSE_LOADING_SAVE_ORDER:
      return {
        ...state,
        licenseLoadingSaveOrder: action.payload,
      };
    case GET_ITEMS_CATALOG:
      return {
        ...state,
        getItemsCatalog: action.payload,
      };
    case LOADING_LOAD_PRODUCTS_ASSIGNMENTS:
      return {
        ...state,
        loadingLoadProductsAssignments: action.payload,
      };
    case LICENSE_SAVE_ORDER_SUCCESS:
      return {
        ...state,
        licenseSaveOrderSuccess: action.payload,
      };
    case SET_MARKET_CONTEXT:
      return {
        ...state,
        marketContext: {
          countryCode: action.payload?.countryCode,
          currency: action.payload?.currency,
          brandName: action.payload?.brandName,
          urlMarketPlace: action.payload?.urlMarketPlace,
          referenceUuid: action.payload.referenceUuid,
        },
      };
    case SAVE_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        saveAssignmentsSuccess: action.payload,
      };
    case SAVING_ASSIGNMENTS_LOADING:
      return {
        ...state,
        savingAssignmentsLoading: action.payload,
      };
    case SAVE_ORDER_SUCCESS:
      return {
        ...state,
        saveOrderSuccess: action.payload,
      };
    case SAVE_ORDER_MARKET_ERROR:
      return {
        ...state,
        saveOrderMarketError: action.payload,
      };
    case PRODUCT_WAS_ASSIGNED:
      return {
        ...state,
        productWasAssigned: action.payload,
      };
    case PAYMENT_RESULT:
      return {
        ...state,
        paymentResult: action.payload,
      };
    case ADD_PROMO_TO_LIST: {
      const newAppliedPromos = [...state.appliedPromos, action.payload];
      sessionStorage.setItem('cart_promos', JSON.stringify(newAppliedPromos));
      return {
        ...state,
        appliedPromos: newAppliedPromos,
      };
    }
    case LOADING_VALIDATE_PROMO_CODE:
      return {
        ...state,
        loadingValidatePromoCode: action.payload,
      };
    case SET_PROMO_FEEDBACK:
      return {
        ...state,
        promoFeedback: action.payload,
      };
    case LOADING_CONTRACT_CUSTOMER_INFO:
      return {
        ...state,
        loadingContractCustomerInfo: action.payload,
      };
    case LOADING_CONTRACT_SUPERVISOR_INFO:
      return {
        ...state,
        loadingContractSupervisorInfo: action.payload,
      };
    case COUNTRIES_FLAGS:
      return {
        ...state,
        countriesFlags: action.payload,
      };
    case CUSTOMER_ASSIGNED_CONTRACTS:
      return {
        ...state,
        customerAssignedContracts: action.payload,
      };
    case CLEAR_SERVICES_DATA_DASHBOARD:
      return {
        ...state,
        getServicesDataDashboard: [],
      };
    case GET_CUSTOMER_EDIT_INFORMATION_LICENSE:
      return {
        ...state,
        customerServiceEditInfoLicense: action.payload,
      };
    case LOADING_CUSTOMER_EDIT_INFORMATION:
      return {
        ...state,
        loadingCustomerEdit: action.payload,
      };
    case LICENSE_LOADING_UPDATE_CUSTOMER:
      return {
        ...state,
        loadingUpdateCustomer: action.payload,
      };
    case LOADING_CONTRACT_ANNULMENT:
      return {
        ...state,
        loadingContractAnnulment: action.payload,
      };
    case CONTRACT_ANNULMENT:
      return {
        ...state,
        contractAnnulmentResult: action.payload,
      };
    default:
      return state;
  }
};
